<template>
    <td
        role="cell"
        :data-p-editable-column="false"
        :data-p-frozen-column="frozen"
        :class="containerClass"
        :style="containerStyle"
    ></td>
</template>

<script>
import DomHandler from '@/common/DOMUtils.js';

export default {
    name: 'EditableEmptyActionCell',
    inject: ['$parentInstance'],
    props: {
        frozen: {
            type: Boolean,
            default: false
        },
        alignFrozen: {
            type: String,
            default: 'left',
            validator: value => ['left', 'right'].includes(value)
        }
    },
    data() {
        return {
            styleObject: {}
        };
    },
    computed: {
        containerStyle() {
            let style = this.frozen ? [this.styleObject] : [];

            return style;
        },
        containerClass() {
            const columnClass = 'md-editable-grid-cell-editable';

            let frozenClass = '';
            if (this.frozen) {
                frozenClass = 'table-frozen-column';
            }

            return [columnClass, frozenClass].filter(x => x.length !== 0);
        }
    },
    methods: {
        updateStickyPosition() {
            if (this.frozen) {
                let align = this.alignFrozen;

                if (align === 'right') {
                    let right = 0;
                    let next = DomHandler.getNextElementSibling(
                        this.$el,
                        '[data-p-frozen-column="true"]'
                    );

                    if (next) {
                        right = DomHandler.getOuterWidth(next) + parseFloat(next.style.right || 0);
                    }

                    this.$set(this.styleObject, 'insetInlineEnd', right + 'px');
                } else {
                    let left = 0;
                    let prev = DomHandler.getPreviousElementSibling(
                        this.$el,
                        '[data-p-frozen-column="true"]'
                    );

                    if (prev) {
                        left = DomHandler.getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                    }

                    this.$set(this.styleObject, 'insetInlineStart', left + 'px');
                }
            }
        }
    },

    mounted() {
        if (this.frozen) {
            this.updateStickyPosition();
        }
    },

    updated() {
        if (this.frozen) {
            this.updateStickyPosition();
        }
    }
};
</script>
